// extracted by mini-css-extract-plugin
export default {"image":"Zoom_image__7MR3x"};